import React, { useEffect, Fragment, useState } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from 'components/Select';
import utils from 'components/utils';

const WishlistSelector = ({ className }) => {
	const [iAmPersonifying] = utils.usePersonification();
	const permissions = useStoreState(state => state.me.permissions);
	const loading = useStoreState(state => state.wishlist.listLight.loading);
	const list = useStoreState(state => state.wishlist.listLight.items);
	const listIsLoaded = useStoreState(state => state.wishlist.listLight.loadedList);
	const load = useStoreActions(dispatch => dispatch.wishlist.listLight.loadTitle);
	const select = useStoreActions(dispatch => dispatch.wishlist.listLight.select);
	const loadItems = useStoreActions(dispatch => dispatch.wishlist.details.load);
	const setSpecialDepots = useStoreActions(dispatch => dispatch.wishlist.details.setSpecialDepots);
	const personify = useStoreState(state => state.me.personify);
	const userData = useStoreState(state => state.me.data);
	const userCode = personify.iAmPersonifying ? personify.target.id : userData.id;
	const [visibleWishlist, setVisibleWishlist] = useState([]);
	const [selectedWishlist, setSelectedWishlist] = useState('');
	const specialEnabled = iAmPersonifying && permissions && permissions['MANAGE_WISHLIST_SPECIAL'];

	/*
	useEffect(
		_ => {
			if (list.length === 0 && !listIsLoaded) {
				load();
			}
		},
		[list, load, listIsLoaded]
	);
	*/

	useEffect(_ => {
		if (!listIsLoaded) load();
	}, []);

	useEffect(
		_ => {
			if (list.length > 0) {
				const enabledList = specialEnabled ? list : list.filter(item => !item.special);
				//Se la WL selezionata è speciale e non sono abilitate le WL speciali seleziono la prima WL visibile
				if (!specialEnabled && list.find(wList => wList.selected).special && enabledList.length > 0) {
					select(enabledList[0].id);
				} else if (enabledList.length > 0) {
					const WLselected = enabledList.find(wList => wList.selected);
					const WLid = WLselected.id;
					setSelectedWishlist(WLid);
					setVisibleWishlist(enabledList);
					if (WLselected.special) {
						loadItems(WLid);
					} else setSpecialDepots([]);
				}
				/*
				const WLid = list.find(wList => wList.selected).id;

				setSelectedWishlist(WLid);
				setVisibleWishlist(enabledList);
				
				
				//In caso di WL speciale carico i dati per recuperare l'eventuale deposito già inserito
				if (list.find(wList => wList.selected).special) loadItems(WLid);
				else setSpecialDepots([]);
*/
			}
		},
		[list]
	);

	return (
		<Fragment>
			{!loading && visibleWishlist.length > 0 && (
				<FormControl variant="outlined" className={className} sx={{ width: '80%' }}>
					<Select value={selectedWishlist} onChange={event => select(event.target.value)}>
						{visibleWishlist.map((item, index) => (
							<MenuItem key={index} value={item.id}>
								{item.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			)}
			{!loading && visibleWishlist.length === 0 && (
				<b style={{ alignSelf: 'center' }}>Nessuna wishlist selezionabile</b>
			)}
		</Fragment>
	);
};

export default WishlistSelector;
